import './App.css';
import PortfolioGrowthChart from './components/PortfolioGrowthChart';

function App() {
  return (
    <div className="App">
      <PortfolioGrowthChart />
    </div>
  );
}

export default App;
